<template>
  <div class="content">
      <NavBar style="position:absolute;top:0;" :navBlock='navBlock' :navtitle='navtitle'></NavBar>
      <div class="home-content">
        <p class="welcome">WELCOME </p>
        <p class="tips">歡迎來JJLin運營平台</p>
        <img src="@/assets/images/common/home-img.png" alt="">
      </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
export default {
  data () {
    return {
      navBlock: '首頁',
      navtitle: '首頁'
    }
  },
  created(){
    // this.$get(`/bulletChat/find/barrage/2`, this.$GLOBAL.jsonConfig)
    //   .then((res) => {
    //   console.log(res)
    //   });
    // console.log('toast')
    // this.$Toast.success({content:'WELCOME',duration:2000})
  },
  components: {
    NavBar
  }
};
</script>

<style lang="less" scoped>
.content{
  background: #F5F5FC;
    .home-content{
      position: relative;
      top: 25%;
      width: 100%;
      img{
        width: 7rem;

        @media (max-width: 768px) {
          width: 90%;
        }
      }
      .welcome{
        font-size: .28rem;
        margin: 0.1rem 0 0.1rem 0;
        color: #333333;
      }
      .tips{
        color: #938EA4;
        margin-bottom: 0.4rem;
        font-size: 0.14rem;
      }
  }
}
  
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue